import { IBaseState } from '..';
import { IUserListingModel } from '../../models/user';
import { IPagination } from '../../models/app-configuration';
import { IAuthConfigModel } from '../../models/user/auth-config.model';
import { IUserconfiguration, IAccountConfiguration, ITwoFactorAuth, INotificationConfig } from '../../models/user-configuration/user-configuration';

export interface IUserState extends IBaseState<{}, {}> {
    listOfUsers?: IUserListingModel[];
    pagination?: IPagination | null;
    authConfig?: IAuthConfigModel;

    userInfo?: IUserconfiguration;
    userInfoOriginal?: IUserconfiguration;

    accountConfiguration?: IAccountConfiguration;
    accountConfigurationOriginal?: IAccountConfiguration;

    twoFactorAuthenticate?: ITwoFactorAuth;
    twoFactorAuthenticateOriginal?: ITwoFactorAuth;

    notificationConfig?: INotificationConfig;
    notificationConfigOriginal?: INotificationConfig;
    userRights?: any;
}

export class UserState implements IUserState {
    isPageRendered?: boolean;
    service?: {};
    searchParam?: {};
    listOfUsers: IUserListingModel[] | null;
    pagination?: IPagination | null;
    authConfig?: IAuthConfigModel;
    userInfo?: IUserconfiguration;
    userInfoOriginal?: IUserconfiguration;
    accountConfiguration?: IAccountConfiguration;
    accountConfigurationOriginal?: IAccountConfiguration;
    twoFactorAuthenticate?: ITwoFactorAuth;
    twoFactorAuthenticateOriginal?: ITwoFactorAuth;
    notificationConfig?: INotificationConfig;
    notificationConfigOriginal?: INotificationConfig;
    userRights?: any;

    constructor(options: IUserState) {
        this.isPageRendered = options.isPageRendered;
        this.service = options.service;
        this.searchParam = options.searchParam;
        this.listOfUsers = null;
        this.pagination = options.pagination || null;
        this.authConfig = null;
        this.userInfo = null;
        this.userInfoOriginal = null;
        this.accountConfiguration = null;
        this.accountConfigurationOriginal = null;
        this.twoFactorAuthenticate = null;
        this.twoFactorAuthenticateOriginal = null;
        this.notificationConfig = null;
        this.notificationConfigOriginal = null;
        this.userRights = null;
    }
}